<template>
  <div class="centered-column">
    <div class="time-entry-not-found">
      <div class="white-card">
        <i class="atto not-found-404"></i>
        <h1>Time entry not found!</h1>
        <p>The time entry you’re trying to review does not exist. Please check the URL and try again.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
name: "TimeEntryNotFoundComponent"
}
</script>

<style lang="scss" scoped>
    .time-entry-not-found{
      padding-top: 60px;

      .white-card{
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        min-height: 393px;
        height: 100%;

        h1{
          font: $roboto-medium 1.25rem/1.75rem $roboto-font;
          color: $atto-font-color;
          margin: 8px 0 0 0;
        }
        p{
          margin: 0;
          color: #666666;
          font: $roboto-regular 0.9375rem/1.5rem $roboto-font;
          max-width: 360px;
          width: 100%;
          text-align: center;
        }

        i.not-found-404{
          width: 87px;
          height: 79px;
          background: url("~@assets/images/not_found_404.svg") no-repeat center;
        }
      }
    }
</style>